<template>
  <b-card class="mb-0 h-100">
    <template #header>
      <i class="fas fa-shield-alt"></i>{{ $lang.Menu.Items.Access.PCI.Contracts }}
    </template>
    <div class="d-flex flex-column h-100">
      <div class="d-flex flex-grow-0">
        <b-row class="w-100">
          <b-col cols="5" class="d-flex">
            <v-select
              v-model="selectedUser"
              :options="users"
              :reduce="user => user.value"
              label="text"
              @input="onSelectUser"
              class="w-100"
              :placeholder="`-- ${$lang.Access.SelectUser} --`"
            >
            </v-select>
          </b-col>

          <b-col cols="2" class="pl-0 justify-content-center">
            <div class="d-flex justify-content-center">
              <b-button variant="third" v-if="selectedUser" class="no-round mx-3" @click="saveUserAccess">{{ $lang.Common.Buttons.Save }}</b-button>
              <b-button variant="third" v-if="selectedContract" class="no-round mx-3" @click="saveContractAccess">{{ $lang.Common.Buttons.Save }}</b-button>
              <b-button variant="third" class="no-round mx-3"
                :title="$lang.Common.CopyTip"
                v-if="selectedUser"
                @click="showModal('copy-modal')">{{ $lang.Common.Buttons.Copy }}</b-button>
            </div>
            <!--v-b-modal-->
            <template>
              <b-modal id="copy-modal" :title="$lang.Common.CopyAccessTitle" v-on:ok="onOk">
                <b-row>
                  <b-col>
                    {{ $lang.Common.OriginCopyUser }}: {{ selectedUserName }}
                    <hr />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="11">
                    <!--SelectBox-->
                    <b-select v-model="selectedUserCopy" :options="users" @change="onSelectUserCopy" >
                      <template #first>
                        <b-form-select-option :value="null" disabled>-- {{ $lang.Access.SelectUser }} --</b-form-select-option>
                      </template>
                    </b-select>
                  </b-col>
                  <b-col cols="1" class="d-flex align-items-center pl-2" style="font-size:x-large;left:-.5em">
                    <!-- + button -->
                    <span>
                      <i class="fas fa-plus-circle text-third clickable pointer" @click="onAddUserCopy"></i>
                    </span>
                  </b-col>
                </b-row>
                <!--radio btn-->
                <b-row>
                  <b-col>
                    <hr/>
                    <label class="pointer">
                      <input type="radio" value="inclusive" class="pointer"
                        :title="$lang.Common.InclusiveCopyTip"
                        v-model="copyType"> {{$lang.Common.InclusiveCopy}}
                    </label>
                    &nbsp;&nbsp;&nbsp;
                    <label class="pointer">
                      <input type="radio" value="exclusive" class="pointer"
                        :title="$lang.Common.ExclusiveCopyTip"
                        v-model="copyType"> {{$lang.Common.ExclusiveCopy}}
                    </label>
                    <i class="fas fa-question-circle pointer tip" :title="$lang.Common.CopyQuestionTip"></i>
                  </b-col>
                </b-row>
                <!--textbox-->
                <b-row>
                  <b-col>
                    <div class="oversize-vertical" style="height:50vh">
                      <div class="item-list" v-for="userCopy in this.copyToUsers" v-bind:key="userCopy.value" >
                        {{userCopy.text}}
                        <span>
                          <i class="fas fa-minus-circle clickable pointer remove-icon"
                            @click="removeUserCopy(userCopy.value)"></i>
                        </span>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-modal>

              <b-modal id="confirm-copy" v-on:ok="onOkConfirm" v-on:cancel="onCancelConfirm">
                <div>
                  {{$lang.Common.ConfirmCopyPrefix}} {{selectedUserName}} {{$lang.Common.ConfirmCopySufix}}
                </div>
              </b-modal>
            </template>
          </b-col>

          <b-col cols="5">
            <v-select
              v-model="selectedContract"
              :options="contracts"
              :reduce="contract => contract.id"
              label="name"
              @input="onSelectContract"
              :placeholder="`-- Selecione um contrato --`">
            </v-select>
          </b-col>

          <b-col cols="5" class="mt-3">
            <label>{{ $lang.Common.LabelFilter }}:</label>
            <b-input type="search" debounce="500" v-model="keyWord" :disabled="!selectedUser && !selectedContract"></b-input>
          </b-col>
          <b-col cols="2"></b-col>
          <b-col cols="5" class="mt-3">
            <label>{{ $lang.Common.LabelFilter }}:</label>
            <b-input type="search" debounce="500" v-model="keyWordSelected" :disabled="!selectedUser && !selectedContract"></b-input>
          </b-col>
        </b-row>
      </div>
      <div id="available-selected" class="d-flex flex-grow-1">
        <b-row v-if="selectedUser" class="w-100">
          <b-col cols="5" class="mt-3">
            <label>{{ $lang.Access.Denied }}:</label>
            <b-form-select id="select-available"
                          class="select-contracts form-control"
                          multiple
                          size="8"
                          :options="availableContracts.visibleOptions"
                          v-model="availableContracts.values"
            >
            </b-form-select>
          </b-col>

          <b-col class="d-flex flex-column text-center mx-auto justify-content-center mt-3">
              <b-button
                variant="light"
                class="mt-2"
                @click="addAllContracts"
              >
                <i class="fas fa-angle-double-right"></i>
              </b-button>

              <b-button
                variant="light"
                class="mt-2"
                @click="addContracts"
              >
                <i class="fas fa-angle-right"></i>
              </b-button>

              <b-button
                variant="light"
                class="mt-2"
                @click="removeContracts"
              >
                <i class="fas fa-angle-left"></i>
              </b-button>

              <b-button
                variant="light"
                class="mt-2"
                @click="removeAllContracts"
              >
                <i class="fas fa-angle-double-left"></i>
              </b-button>
          </b-col>

          <b-col cols="5" class="mt-3">
            <label>{{ $lang.Access.Allowed }}:</label>
            <b-form-select id="select-allowed"
                          class="select-contracts form-control"
                          multiple
                          size="8"
                          :options="selectedContracts.visibleOptions"
                          v-model="selectedContracts.values"
            >
            </b-form-select>
          </b-col>
        </b-row>
        <b-row v-if="selectedContract" class="w-100">
          <b-col cols="5" class="mt-3">
            <label>{{ $lang.Access.Denied }}:</label>
            <b-form-select id="select-available"
                          class="select-contracts form-control"
                          multiple
                          size="8"
                          :options="availableUsers.visibleOptions"
                          v-model="availableUsers.values"
            >
            </b-form-select>
          </b-col>

          <b-col class="d-flex flex-column text-center mx-auto justify-content-center mt-3">
              <b-button
                variant="light"
                class="mt-2"
                @click="addAllUsers"
              >
                <i class="fas fa-angle-double-right"></i>
              </b-button>

              <b-button
                variant="light"
                class="mt-2"
                @click="addUsers"
              >
                <i class="fas fa-angle-right"></i>
              </b-button>

              <b-button
                variant="light"
                class="mt-2"
                @click="removeUsers"
              >
                <i class="fas fa-angle-left"></i>
              </b-button>

              <b-button
                variant="light"
                class="mt-2"
                @click="removeAllUsers"
              >
                <i class="fas fa-angle-double-left"></i>
              </b-button>
          </b-col>

          <b-col cols="5" class="mt-3">
            <label>{{ $lang.Access.Allowed }}:</label>
            <b-form-select id="select-allowed"
                          class="select-contracts form-control"
                          multiple
                          size="8"
                          :options="selectedUsers.visibleOptions"
                          v-model="selectedUsers.values"
            >
            </b-form-select>
          </b-col>
        </b-row>
      </div>
    </div>

  </b-card>
</template>

<script>
import contracts from './contracts'
export default contracts
</script>

<style scoped>
  #available-selected select.select-contracts {
    height: calc(100% - 30px);
  }
  .oversize-vertical {
    border: 1px solid #BABACA;
    border-radius: 8px;
    padding: 0.5em;
    max-height: 40vh;
    overflow-y: scroll;
  }
  .pointer {
    cursor: pointer;
  }
  .remove-icon {
    color:red;
    float: right;
    margin-top: 3px;
  }
  .item-list {
    border-bottom: 1px solid #dedede;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .item-list:hover {
    background-color: #dedede;
    transition: 200ms;
  }
  .tip {
    color: blue;
    float: right;
    font-size: larger;
  }
  .tip:hover {
    color: cadetblue;
    transition: 300ms;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/access/pci/contracts/contracts.vue